import { LoadingSpinner } from '@conversed/ui/src/components/spinner/LoadingSpinner';
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { LOGIN_PAGE_ROUTE } from '../../constants/routes';
import type { IRoute } from '../../interfaces/IRoutes';
import { UnauthenticatedAppRoutes } from '../routes/UnauthenticatedAppRoutes';

export const UnauthenticatedRouter: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner visible />}>
      <Routes>
        {UnauthenticatedAppRoutes.map((route: IRoute) => {
          const { path, component, exact } = route;
          return (
            <Route
              key={path}
              path={exact ? path : `${path}/*`}
              element={React.createElement(component)}
            />
          );
        })}

        <Route path='*' element={<Navigate to={LOGIN_PAGE_ROUTE} />} />
      </Routes>
    </Suspense>
  );
};
